import ContentsTypes from "@shared/enums/contentsTypes";
import customTypes from "@project/enums/contentsCustomTypes.enum";
const NAVY = "hsl(240,5%,16%)";
const HIGHLIGHT_COLOR = "#1E37FF";
const createFileImage = (key) => ({
    key,
    type: ContentsTypes.FILE_IMAGE,
    value: JSON.stringify({
        id: "",
        name: "",
        mimeType: "image/svg+xml",
        publicUrl: `/api/medias/""`,
        url: `/api/medias/""`,
        alt: "",
        title: "",
    }),
});
const createSectionText = (label, text, color) => ({
    key: "dynamicElements",
    type: ContentsTypes.TEXT,
    value: encodeURIComponent(`<p style="line-height:1.6;"><span style="color:${color};font-size:16px;"><strong>${label}</strong></span></p><p style="line-height:1.6;"><span style="font-size:16px;">${text}</span></p>`),
    children: [],
});
export const createIllustrationTabItem = (item) => ({
    key: "items",
    type: customTypes.ILLUSTRATION_TAB_ITEM,
    value: "",
    children: [
        createFileImage("icon"),
        { key: "label", type: ContentsTypes.INPUT, value: item.label },
        {
            key: "description",
            type: ContentsTypes.INPUT,
            value: item.description || "",
        },
        {
            key: "borderColor",
            type: ContentsTypes.COLOR,
            value: item.borderColor || "#0000FF",
        },
        createFileImage("illustration"),
        {
            key: "dynamicPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: item.sections.map((section, index) => createSectionText(section.label, section.text, index === 1 ? HIGHLIGHT_COLOR : NAVY)),
        },
    ],
});
export const createIllustrationTabs = (orientation, items) => ({
    key: "dynamicElements",
    type: customTypes.ILLUSTRATION_TABS,
    value: "",
    children: [
        {
            key: "orientation",
            type: ContentsTypes.RADIO_GROUP,
            value: orientation,
        },
        {
            key: "dynamicList",
            type: ContentsTypes.DYNAMIC_LIST,
            value: "",
            children: [
                {
                    key: "contentType",
                    value: customTypes.ILLUSTRATION_TAB_ITEM,
                    children: items.map(createIllustrationTabItem),
                },
            ],
        },
    ],
});
